/* eslint-disable react-hooks/exhaustive-deps */
import React, { ReactNode, useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Grid,
} from "@mui/material";
import { FleetDashboardOverviewApi } from "../../../../API/Iot-Api/FleetDashboardOverview/FleetDashobardOverview";
import { IotReportResponse } from "../../../../@Types/DRO/IotApiResponse/FleetOverviewResponse";
import "./style.css";
import { useLocation } from "react-router-dom";
import { CSVLink } from "react-csv";
import { blue } from "@mui/material/colors";

const AlarmReports = () => {
  const [searchValInput, setSearchValInput] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState<any>();
  const [iotReport, setIotReport] = useState<IotReportResponse | null>(null);
  const [iotReportDownload, setIotReportDownload] =
    useState<IotReportResponse | null>(null);
    const [userRole, setUserRole] = useState<string | null>(null);

  const location = useLocation();

  const [downloadpage, setDownloadPage] = useState(1);
  const [downloadrowsPerPage, setDownloadRowsPerPage] = useState(50000);
  useEffect(()=>{
    const role = localStorage.getItem("authority");
    setUserRole(role);
  },[])
  const pageRange = 5;
  const hubName = location.state.hubName;
  const category = location.state.countType;
  const iotType = location.state.iotTypeValue
  const tableHeaderCellStyle = {
    fontWeight: 600,
    fontSize: "14px",
    color: "#455A64",
    font: "Rubik",
  };
  const tableBodyCellStyle = {
    fontWeight: 400,
    fontSize: "14px",
    color: "#A4A2A2",
    font: "Rubik",
  };
  // Dummy data for tables
  const formatTime = (dateTime: string) => {
    const formattedDateTime = dateTime.replace("T", " "); // Replace "T" with a space
    const date = new Date(formattedDateTime); // Convert to Date object
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0"); // Format hours to 2 digits
    const minutes = String(date.getMinutes()).padStart(2, "0"); // Format minutes to 2 digits
    const seconds = String(date.getSeconds()).padStart(2, "0"); // Format seconds to 2 digits

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`; // Return date and time in YYYY-MM-DD HH:MM:SS format
  };
  const pageCount = Math.ceil(totalCount / rowsPerPage);
  const handlePageChange = (newPage: number) => {
    const newPageNumber = Math.max(1, Math.min(newPage + 1, pageCount));
    setPage(newPageNumber - 1);
  };

  const renderPageNumbers = () => {
    const pagesToShow = Math.min(pageCount, pageRange);
    const startPage = Math.max(
      0,
      Math.min(page - Math.floor(pageRange / 2), pageCount - pagesToShow)
    );

    return Array.from({ length: pagesToShow }, (_, index) => {
      const pageNumber = startPage + index + 1;
      return (
        <span
          key={index}
          onClick={() => handlePageChange(pageNumber - 1)}
          className={page === pageNumber - 1 ? "active" : "unactive"}
          style={{ marginLeft: "6px" }}
        >
          {pageNumber}
        </span>
      );
    });
  };

  useEffect(() => {
    //const searcValue = `${searchValInput ? `?search=${searchValInput}` : ""}`;
    const fetchIotReport = async () => {
      try {
        const data: IotReportResponse =
          await FleetDashboardOverviewApi.api.getIotReport(
            hubName,
            category,
            page + 1,
            rowsPerPage,
            iotType
          );

        setIotReport(data);
        setTotalCount(data.data.total_count);
      } catch (error) {
        console.error("Error fetching fleet summary", error);
      }
    };
    fetchIotReport();
  }, [hubName, category, page, rowsPerPage, iotType]);

  useEffect(() => {
    //const searcValue = `${searchValInput ? `?search=${searchValInput}` : ""}`;
    const fetchIotReportDownload = async () => {
      try {
        const data: IotReportResponse =
          await FleetDashboardOverviewApi.api.getIotReportDownload(
            hubName,
            category,
            downloadpage,
            downloadrowsPerPage,
            iotType
          );

        setIotReportDownload(data);
        setTotalCount(data.data.total_count);
      } catch (error) {
        console.error("Error fetching fleet summary", error);
      }
    };
    fetchIotReportDownload();
  }, [hubName, category, downloadpage, downloadrowsPerPage]);

  const iotReportButton = [
    { label: "User ID", key: "user_id" },
    { label: "Mobile No", key: "rider_mobile" },
    { label: "Vehicle No", key: "qr_code" },
    { label: "Fleet Model	", key: "fleet_name" },
    { label: "End Time", key: "time" },
    { label: "Latitude", key: "lat" },
    { label: "Longitude", key: "lng" },
    { label: "Hub Name", key: "hub_name" },
    { label: "IOT Type", key: "iot_type" },
    { label: "Device ID", key: "imei" },
    {
      label: "Day Since Last Iot Packet Received",
      key: "days_since_last_update",
    },
    { label: "Number Of Days On Ride", key: "days_since_ride_started" },
  ];
  return (
    <div className="w-full flex bg-white min-h-80 shadow-lg p-3 rounded-xl">
      <div className="w-full">
        <Grid container spacing={5} className="w-full flex justify-between ">
          <Grid item md={3}>
            <div className="flex ml-4">
              <h2 className="text-center ml-2 mx-1 mt-2 font-bold text-base text-black pb-2">
                IOT Reports{" "}
              </h2>
            </div>
          </Grid>
          <Grid item md={9}>
            <div className="flex mr-4">
              <div className="flex w-full justify-end">
              {(userRole === "ROLE_FLEET_SUPER_ADMIN" || 
    userRole === "ROLE_ADMIN" || 
    userRole === "ROLE_CO_ADMIN") && ( // Ensure this condition is checked
                <div>
                  <CSVLink
                    data={iotReportDownload?.data.hubwise_status_counts || []}
                    headers={iotReportButton}
                    filename={`Iot_Report.csv`}
                    style={{ marginRight: "10px" }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#06B681",
                        padding: "8px 20px",
                        color: "#fff",
                        borderRadius: "25px",
                        width: "100%",
                        textTransform: "none",
                        marginLeft: "10px",
                      }}
                    >
                      Download
                    </Button>
                  </CSVLink>
                </div>
              )}
              </div>
            </div>
          </Grid>
        </Grid>
        <hr className="my-4" />
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={tableHeaderCellStyle} sx={{ minWidth: 120 }}>
                  User ID
                </TableCell>
                <TableCell style={tableHeaderCellStyle} sx={{ minWidth: 150 }}>
                  Mobile No
                </TableCell>
                <TableCell style={tableHeaderCellStyle} sx={{ minWidth: 110 }}>
                  Vehicle No
                </TableCell>
                <TableCell style={tableHeaderCellStyle} sx={{ minWidth: 150 }}>
                  Fleet Model
                </TableCell>
                <TableCell style={tableHeaderCellStyle} sx={{ minWidth: 200 }}>
                  End Time
                </TableCell>
                <TableCell style={tableHeaderCellStyle} sx={{ minWidth: 100 }}>
                  End Location
                </TableCell>
                <TableCell style={tableHeaderCellStyle} sx={{ minWidth: 200 }}>
                  Hub Name
                </TableCell>
                <TableCell style={tableHeaderCellStyle} sx={{ minWidth: 150 }}>
                  IOT Type
                </TableCell>
                <TableCell style={tableHeaderCellStyle} sx={{ minWidth: 130 }}>
                  Device ID
                </TableCell>
                <TableCell style={tableHeaderCellStyle} sx={{ minWidth: 330 }}>
                  Day Since Last Iot Packet Received
                </TableCell>
                <TableCell style={tableHeaderCellStyle} sx={{ minWidth: 230 }}>
                  Number Of Days On Ride
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {iotReport?.data?.hubwise_status_counts?.map((item, index) => (
                <TableRow key={index}>
                  <TableCell style={tableBodyCellStyle}>
                    {item.user_id}
                  </TableCell>
                  <TableCell style={tableBodyCellStyle}>
                    {item.rider_mobile}
                  </TableCell>
                  <TableCell style={tableBodyCellStyle}>
                    {item.qr_code}
                  </TableCell>
                  <TableCell style={tableBodyCellStyle}>
                    {item.fleet_name}
                  </TableCell>
                  <TableCell style={tableBodyCellStyle}>
                    {" "}
                    {formatTime(item.time)}
                  </TableCell>
                  <TableCell style={tableBodyCellStyle}>
                    <a
                      style={{ color: blue[400] }}
                      href={`https://www.google.com/maps?q=${item.lat.toFixed(
                        6
                      )},${item.lng.toFixed(6)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.lat.toFixed(6)},{item.lng.toFixed(6)}
                    </a>
                  </TableCell>
                  <TableCell style={tableBodyCellStyle}>
                    {item.hub_name}
                  </TableCell>
                  <TableCell style={tableBodyCellStyle}>
                    {item.iot_type}
                  </TableCell>
                  <TableCell style={tableBodyCellStyle}>{item.imei}</TableCell>
                  <TableCell style={tableBodyCellStyle}>
                    {item.days_since_last_update}
                  </TableCell>
                  <TableCell style={tableBodyCellStyle}>
                    {item.days_since_ride_started}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <div className="pl-2 pt-4 pb-2 pr-16">
          <div
            className="pagination"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div>
              <button
                onClick={() => handlePageChange(page - 1)}
                disabled={page === 0}
                style={{
                  fontFamily: "Rubik",
                  fontSize: "20px",
                  marginRight: "6px",
                }}
              >
                {"<"}
              </button>
              {renderPageNumbers()}
              <button
                onClick={() => handlePageChange(page + 1)}
                disabled={page >= pageCount - 1}
                style={{
                  fontFamily: "Rubik",
                  fontSize: "20px",
                  marginLeft: "6px",
                }}
              >
                {">"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlarmReports;
